import React from "react";

export default function RestlessBooleanFormatter(cellContent) {
  return <div>{cellContent ? "Yes" : "No"}</div>;
}